export default __webpack_public_path__ + "static/media/icon-money.448ae565.png";